<template>
	<div class="body">
		<div class="main flex-column flex-center">
			<img class="logo" src="@/assets/image/login/logo.png"></img>
				
			<div class="login flex-center">
				<div class="cover flex-center">
					<img src="@/assets/image/login/login.png">
				</div>
				<div class="form flex-grow">
					<div class="title flex-baseline">
						<h1>账号登录</h1>
						<p>ACCOUNT LOGIN</p>
					</div>
					<div class="item flex-center">
						<i class="tf">&#xe670;</i>
						<input v-model="username" class="flex-grow" type="text" placeholder="请输入您的姓名" @keydown.enter="loginHandle">
					</div>
					<div class="item flex-center">
						<i class="tf">&#xe73d;</i>
						<input v-model="phone" class="flex-grow" type="text" placeholder="请输入您的手机号码" @keydown.enter="loginHandle">
					</div>
					<button @click="loginHandle">立即登录</button>
					<button class="tacs-sso-btn" @click="tacsSsoLogin">豫事办登录</button>
				</div>
			</div>
			
			<div class="copyright">
				<p>浙江银江智能信息技术有限公司 提供技术支持</p>
				<p><span>平台客服邮箱：yjszbh@163.com</span><a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备19010525号-1</a></p>
			</div>
		</div>
		
		<smscode ref="sms" @getSmscode="getSmscode" @submit="validHandle"></smscode>
	</div>
</template>

<script>
	import smscode from '@/components/module/smscode.vue'
	import fun from '@/assets/script/function.js'
	
	export default {
		components: {
			smscode
		},
		
		data() {
			return {
				username: '',
				phone: '',
				showQrcode: false
			};
		},
		
		mounted() {
			window.addEventListener('message', res => {
				if (res.data.code) {
					this.request({
						url: '/zzd/login',
						data: {
							type: 2,
							code: res.data.code
						},
						loading: true,
						success: data => {
							fun.setCookie('session_id', data.sessionId);
							this.$store.commit('setUserInfo', data);
							this.navigateTo('/');
						},
						error: function (data,b,c) {
							alert("系统出错！");
						}
					});
				}
			});
		},
		
		methods: {
			loginHandle() {
				if (!this.username.trim() || !this.phone.trim()) {
					this.$message({
						text: '请输入姓名和手机号'
					});
					return;
				}
				
				this.$refs.sms.getSmscode();
			},
			
			getSmscode(next) {
				this.request({
					url: '/user/qy/login_code',
					data: {
						user_realname: this.username,
						user_phone: this.phone
					},
					loading: true,
					success: data => {
						this._token = data;
						next();
						this.$refs.sms.open(this.phone);
					}
				});
			},
			
			validHandle(code, next) {
				if (!code) {
					this.$message({
						text: '请输入短信验证码'
					});
					return;
				}
				
				this.request({
					url: '/user/qy/login',
					data: {
						code_token: this._token,
						verify_code: code
					},
					loading: true,
					success: data => {
						fun.setCookie('session_id', data.sessionId);
						this.$store.commit('setUserInfo', data);
						this.navigateTo('/');
					}
				});
			},
			
			tacsSsoLogin() {
				var url = 'https://zjcs.zhoukouzhengwu.cn/auth/sso/authorize?redirect_url=' + encodeURIComponent(window.location.origin + '/#/tacs_sso/callback');
				window.location.href = url;
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		overflow: hidden;
		background-color: #fff
		background-image: url('~@/assets/image/login/bg.jpg');
		background-position: top center;
		background-size: auto 611px;
		background-repeat: no-repeat;
	}
	
	.main {
		width: 950px;
		margin: 100px auto 0;
	}
	
	.logo {
		align-self: flex-start;
		height: 36px;
	}

	.login {
		width: 100%;
		height: 480px;
		border-radius: 18px;
		margin-top: 30px;
		background: rgba(255,255,255,.95);
		box-shadow: 0 0 10px 0 rgba(30,84,132,.2);
		
		.cover {
			width: 512px;
			height: 375px;
			border-right: 1px solid #eee;
			
			img {
				width: 440px;
			}
		}
		
		.form {
			padding: 0 48px;
			margin-bottom: 40px;
		}
		
		.title {
			gap: 8px;
			margin-bottom: 28px;
			font-size: 12px;
			color: #bbb;
			
			h1 {
				font-size: 26px;
				font-weight: normal
				color: #000;
			}
		}
		
		.item {
			height: 40px;
			border: 1px solid #ddd;
			border-radius: 4px;
			margin-bottom: 20px;
			font-size: 0;
			
			&:focus-within {
				border-color: #1492FF;
				
				.tf {
					color: #1492FF;
				}
			}
			
			.tf {
				width: 45px;
				font-size: 18px;
				text-align: center;
				color: #bbb;
			}
			
			input {
				height: 100%;
				border: none;
				font-size: 14px;
			}
		}
		
		button {
			display: block;
			width: 100%;
			height: 50px;
			border: none;
			border-radius: 25px;
			font-size: 20px;
			color: #fff;
			background: #1492FF;
			cursor: pointer;
			
			&:hover {
				opacity: .9;
			}
			
			&.tacs-sso-btn {
				margin-top: 16px;
				background: #fff;
				color: #1492FF;
				border: 1px solid #1492FF;
				
				&:hover {
					background: #f0f8ff;
				}
			}
		}
		
		.link {
			width: 400px;
			margin-left: 130px;
			margin-top: 25px;
			font-size: 16px;
			color: #3296FA;
			
			a {
				color: #FEDD00;
			}
		}
	}
	
	.copyright {
		margin-top: 24px;
		line-height: 24px;
		font-size: 13px;
		color: #999;
		
		p {
			float: left;
			
			&:nth-child(2) {
				float: right;
			}
			
			span, a {
				margin-left: 1em;
				text-decoration: none;
			}
			
			a {
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
</style>